import { ROUTE_NAMES } from './'
export const CAPTURE_METHOD = 1
export const LIVE_MODE = true
export const TRANSACTION_METHOD = 110
export const HIDE_UPI_INTENT_FEATURE = false

export const THEME_PADDING = {
  HORIZONTAL_PADDING: 24,
  VERTICAL_PADDING: 24,
}

export const EMI = {
  CREDIT_CARD: '00',
  DEBIT_CARD: '01',
  CARDLESS: '02',
  ALL: '03',
  CREDIT_CARD_ALL: '04',
  DEBIT_CARD_ALL: '05',
  NO_LOW_COST_EMI_ALL: '06',
  NO_LOW_COST_CC_ALL: '07',
  STANDARD_EMI_ALL: '08',
  NO_COST_CARD_EMI: '09',
  LOW_COST_CARD_EMI: '10',
  STANDARD_CARD_EMI: '11',
  CARD_EMI: '12',
}

export const TEMPLATE: any = {
  MILK_BASKET: '100',
  THEMED_TEMPLATE: '101',
}
export const EMI_SCHME_TYPE = {
  EXTERNAL: '02',
  INTERNAL: '01',
}

export const EMI_TYPES = {
  STANDARD: '00',
  NO_COST: '01',
  EMI_CASHBACK: '02',
  LOW_COST: '03',
}

export const CARD_ELIGIBLE = {
  eligible: 'eligible',
  not_eligible: 'not_eligible',
}

export const EMI_CARDTYPE = {
  CREDIT_CARD: '00',
  DEBIT_CARD: '01',
  CARDLESS: '02',
  CARDLESS_EMI: '03',
}

export const HEADER: any = {
  emicard: 'EMI ON Credit Card',
  emicardDc: 'EMI ON Debit Card',
  emiplans: 'SELECT EMI PLAN',
  review: 'SUBSCRIPTION REVIEW',
  checkEligibility: 'Eligibility',
  eligibleBankList: 'EMI',
  selectEmiPlans: 'EMI',
  proceedToPayment: 'Payment',
}
let width = 630,
  height = 440,
  top = 0,
  left = 20 // default sizes

if (window.screen) {
  console.log('window.scree', window.screen)
  width = (window.screen.availWidth * 80) / 100
  height = (window.screen.availHeight * 80) / 100
  top = window.outerHeight / 2 + window.screenY - height / 2
  left = window.outerWidth / 2 + window.screenX - width / 2
}

export const windowConfig = `toolbar=0,status=0,width=${width},height=${height}, top=${top}, left=${left}`

export const MERCHANT_OUTPUT_DOMAIN = 'PROFILE'
export const FINANCIAL_PROFILE = 'FINANCIAL_PROFILE'
export const MERCHANT_MEDIA_TYPE = 'application/json'

export const MERCHANT_CONFIG_TYPE = 'ALL'
export const MERCHANT_CONFIG_STATUS = 'ACTIVE'

export const CARD_METHOD_SC_TYPE = 310
export const CARD_METHOD_SC_SUBTYPE = 590
export const EMI_METHOD_CARDLESS_SUBTYPE = 612

export const TOKEN_EXPIRY_CODE = '33708'

export const DC_STATUS = 'DELETE'

export const UPI_METHOD_TYPE = 471
export const UPI_LIVEMODE = false
export const UPI_PAYER_TYPE = 1
export const UPI_PAYER_SUBTYPE = 1

export const UPI_PAYEE_COUNTRY_CODE = '91'

export const BIN_CARD_LENGTH = 16
export const BIN_OPERATION_CODE = 'BIN'
export const BIN_APP_CODE = '101'

export const SC_ENTITY_TYPE = '12'
export const SC_USER_ID = 'jfsUserId'

export const errorMessage = 'Something went wrong, please try again'

export const errorTitle = 'Payment Failed'

export const PAYMENT_SCREENS = {
  jiomoney: 'jiomoney',
  savedcard: 'savedcard',
  newcard: 'newcard',
  creditcard: 'creditcard',
  ccdccard: 'ccdccard',
  paylater: 'paylater',
  sodexo: 'sodexo',
  debitcard: 'debitcard',
  netbanking: 'netbanking',
  upi: 'upi',
  wallet: 'wallet',
  emi: 'emi',
  offers: 'offers',
  corporateNetbanking: 'corporatenetbanking',
  jiopayfinancehub: 'jiopayfinancehub',
  scanAndPay: 'scanAndPay',
}

export const pages = {
  init: 'init',
  modes: 'modes',
  payment: 'payment',
  ppilimit: 'ppilimit',
  progress: 'progress',
  paymentstatus: 'paymentstatus',
  redirectToBank: 'redirectToBank',
  paymentProcessing: 'paymentProcessing',
  payments: 'payments',
  transactionDetails: 'transactionDetails',
  transactionCancelled: 'transactionCancelled',
  setting: 'setting',
  ErrorView: 'ErrorView',
  login: 'login',
  signup: 'signup',
  authentication: 'authentication',
  summary: 'summary',
  newcard: ROUTE_NAMES[PAYMENT_SCREENS.ccdccard],
  netbanking: ROUTE_NAMES[PAYMENT_SCREENS.netbanking],
  savedcard: 'savedcard',
  upi: ROUTE_NAMES[PAYMENT_SCREENS.upi],
  emi: ROUTE_NAMES[PAYMENT_SCREENS.emi],
  progress_slash: '/progress',
  handle: 'handle',
  sessionExpired: 'sessionExpired',
  emicard: 'emicard',
  emireview: 'emireview',
  offers: ROUTE_NAMES[PAYMENT_SCREENS.offers],
  wallet: ROUTE_NAMES[PAYMENT_SCREENS.wallet],
  scConsent: 'scconsent',
  review: 'review',
  allbanks: 'nb',
  allUpiApps: 'upiapps',
  allWallets: 'wallets',
  foodcard: 'foodcard',
  paylater: 'paylater',
  emiSavedCard: 'emiSavedCard',
  jioFinanceHub: 'JioPay EasyEMI',
  checkEligibility: 'checkEligibility',
  eligibleBankList: 'eligibleBankList',
  selectEmiPlans: 'selectEmiPlans',
  proceedToPayment: 'proceedToPayment',
  extraInfoInput: 'extraInfoInput',
}

export const OFFER_TYPE = {
  INSTANT: 1, // We have to remove the cash back amount from the actual amount
  CASH_BACK: 2,
}

export const SUBSCRIPTION_FREQUENCY: any = {
  '1': 'Once',
  '2': 'Daily',
  '3': 'Weekly',
  '4': 'Monthly',
  '5': 'Quarterly',
  '6': 'Half Yearly',
  '7': 'Yearly',
  '8': 'As presented',
}

export const SUBSCRIPTION_RULE: any = {
  MAX: 'Maximum',
  EXACT: 'Exact',
}

export const CARD_TYPE = {
  DEBIT_CARD: 110,
  CREDIT_CARD: 130,
  FOOD_CARD: 140,
}

export const PAYMENT_MODE_TYPE = {
  PURCHASE: 110,
  EMI: 114,
  UPI: 212,
  SUBSCRIPTION: 310,
}

export const PAYMENT_MODE_SUBTYPES: any = {
  UPI: 566,
  NB: 581,
  CARD: 582,
  WALLET: 579,
  CARDLESS_EMI: 600,
  EMI: 114, //TYPE
  PAYLATER: 601,
  FOOD_CARD: 613,
  NATIVE_UPI: 580,
  CORP_NB: 620,
  NEW_TO_CREDIT: 619,
  UPI_SUBSCRIPTION: 589,
  CARD_SUBSCRIPTION: 590,
}

export const PAYMENT_TYPE = {
  CREDIT_CARD: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
  CC_DC_CARD: 'Credit/Debit Card',
  UPI: 'Upi',
  WALLET: 'Wallet',
  NB: 'Netbanking',
  EMI: 'EMI',
  PAY_LATER: 'Pay Later',
  SODEXO: 'Sodexo',
  CORP_NB: 'Corporate Netbanking',
}

export const HEADER_TITILES = {
  [PAYMENT_SCREENS.netbanking]: 'Internet Banking',
  [PAYMENT_SCREENS.debitcard]: 'Debit Card',
  [PAYMENT_SCREENS.creditcard]: 'Credit Card',
  [PAYMENT_SCREENS.ccdccard]: 'Credit/Debit Card',
  [PAYMENT_SCREENS.upi]: 'UPI',
  [PAYMENT_SCREENS.wallet]: 'Wallet',
  [PAYMENT_SCREENS.emi]: 'EMI',
  [PAYMENT_SCREENS.offers]: 'Offers',
  [PAYMENT_SCREENS.paylater]: 'Pay Later',
}

export const getOfferSelectedPaymentType = (pmType: number, pmSubType: number) => {
  switch (pmSubType) {
    case pmType === PAYMENT_MODE_TYPE.PURCHASE && PAYMENT_MODE_SUBTYPES.UPI:
      return PAYMENT_SCREENS.upi
    case pmType === PAYMENT_MODE_TYPE.PURCHASE && PAYMENT_MODE_SUBTYPES.NB:
      return PAYMENT_SCREENS.netbanking
    case pmType === PAYMENT_MODE_TYPE.PURCHASE && PAYMENT_MODE_SUBTYPES.CARD:
      return PAYMENT_SCREENS.ccdccard
    case pmType === PAYMENT_MODE_TYPE.PURCHASE && PAYMENT_MODE_SUBTYPES.WALLET:
      return PAYMENT_SCREENS.wallet
    case pmType === PAYMENT_MODE_TYPE.EMI && PAYMENT_MODE_SUBTYPES.CARD:
      return PAYMENT_SCREENS.jiopayfinancehub
    // case pmType === PAYMENT_MODE_TYPE.EMI && PAYMENT_MODE_SUBTYPES.CARDLESS_EMI:
    //  return PAYMENT_SCREENS.emi
    case pmType === PAYMENT_MODE_TYPE.PURCHASE && PAYMENT_MODE_SUBTYPES.PAYLATER:
      return PAYMENT_SCREENS.paylater
    default:
      return 'invalid'
  }
}
export const ADD_NEW_UPI = 'Add New UPI ID'
export const CALLBACK_URL = 'http://psp-mandate-merchant-sit.jiomoney.com:3003/merchantsimulator'
export const REDIRECTION_DELAY: number = 5 // In mill Seconds
export const CHILD_STATUS_CHECK_TIMEOUT = 500 // Milliseconds
const { REACT_APP_ENDPOINT = '' } = process.env
export const NETBANKING_RURL_HOST_NAME = `${REACT_APP_ENDPOINT}/transaction/details`

export const statusMap = {
  S: 'success',
  SUCCESS: 'success',
  F: 'failed',
  FAILED: 'failed',
  INITIATED: 'pending',
  PENDING: 'pending',
  Default: 'pending',
}

export const MAX_RETRIES_EXCEEDED_ERROR = 'Max Retry limit exceeded'
export const yellowThemeColor = '#F5AE3C'
export const yellowLightColor = '#FEF5E6'
export const greenThemeColor = '#4EA86F'
export const redThemeColor = '#DE0000'
export const IS_NTC_ENABLED = true
export const MERGE_NB_CNB = false
